import React, { useMemo } from "react";
import { MenuItemWrapper } from "./styles";
import { useLocation } from "react-router";
import { userHasViewPermission } from "utlis/utils"; // Note: Check if "utlis" is a typo for "utils"

function MenuItem({ children, path, subPaths = [] }) {
  const location = useLocation();

  // FIX: Remove useMemo here. It's causing the stale logic.
  // This will now re-evaluate whenever the component re-renders.
  const finalPath = (path === "/v1" && JSON.parse(localStorage.getItem("login_profile"))?.is_multiple_company_mapped) 
    ? "/v1/overview" 
    : path;

  const isSelected = useMemo(() => {
    const currentPath = location.pathname;

    if (currentPath === finalPath) {
      return true;
    }

    return subPaths.some((subPath) => {
      if (!subPath) return false;
      const basePath = subPath.replace("/*", "");
      return currentPath.startsWith(basePath);
    });
    // Add finalPath here so isSelected updates when the path logic changes
  }, [location.pathname, finalPath, subPaths]);

  return (
    <MenuItemWrapper to={finalPath} isSelected={isSelected}>
      <li>{children}</li>
    </MenuItemWrapper>
  );
}

export default MenuItem;